// extracted by mini-css-extract-plugin
export default {"timeend":"TimeEnd_timeend__+r2r7","timeend_dots":"TimeEnd_timeend_dots__HeDZk","timeend_btn":"TimeEnd_timeend_btn__FtE9J"};